export const dayLabel = 'day'
// eslint-disable-next-line new-cap
export const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
